<template>
  <div>
    <div>
      <label class="label">Test-email</label>
      <input class="input" v-model="email">
      <button class="button is-primary" @click="sendTestEmail()">Skicka</button>
    </div>
    <div>
      <h3>Mallar</h3>
      <button class="button is-primary" @click="workOrderUpdated()">Tjänst uppdaterad</button>
      <button class="button is-primary" @click="photographerAssigned()">Fotograf tilldelad</button>
      <button class="button is-primary" @click="editorAssigned()">Redigerare tilldelad</button>
      <button class="button is-primary" @click="coordinateProject()">Koordinera ärende</button>
      <button class="button is-primary" @click="registrationCompleteViaEmailToBroker()">Ärende registrerat via mail</button>
      <button class="button is-primary" @click="registrationCompleteViaVitecToBroker()">Ärende registrerat via Vitec</button>
      <div v-html="emailTemplate"></div>
    </div>
  </div>
</template>

<script>
import $axios from '@/axios-instance.js'

export default {
  data () {
    return {
      email: 'marcus@renheim.com',
      emailTemplate: null
    }
  },

  methods: {
    sendTestEmail () {
      $axios.get(`${process.env.ROOT_API}/dev/email/${this.email}`).then(response => {
        this.$toast(response.data.message, 'success')
      })
    },

    workOrderUpdated () {
      this.emailTemplate = null
      $axios.get(`${process.env.ROOT_API}/dev/email-template-work-order-update`)
        .then(response => {
          this.emailTemplate = response.data.html
        })
        .catch(error => {
          console.log(error.response.data.devMessage)
        })
    },

    photographerAssigned () {
      this.emailTemplate = null
      $axios.get(`${process.env.ROOT_API}/dev/email-template-photographer-assigned`)
        .then(response => {
          this.emailTemplate = response.data.html
        })
        .catch(error => {
          console.log(error.response.data.devMessage)
        })
    },

    editorAssigned () {
      this.emailTemplate = null
      $axios.get(`${process.env.ROOT_API}/dev/email-template-editor-assigned`)
        .then(response => {
          this.emailTemplate = response.data.html
        })
        .catch(error => {
          console.log(error.response.data.devMessage)
        })
    },

    coordinateProject () {
      this.emailTemplate = null
      $axios.get(`${process.env.ROOT_API}/dev/email-template-coordinate-project`)
        .then(response => {
          this.emailTemplate = response.data.html
        })
        .catch(error => {
          console.log(error.response.data.devMessage)
        })
    },

    registrationCompleteViaEmailToBroker () {
      this.emailTemplate = null
      $axios.get(`${process.env.ROOT_API}/dev/email-registration-complete-via-email-to-broker`)
        .then(response => {
          this.emailTemplate = response.data.html
        })
        .catch(error => {
          console.log(error.response.data.devMessage)
        })
    },

    registrationCompleteViaVitecToBroker () {
      this.emailTemplate = null
      $axios.get(`${process.env.ROOT_API}/dev/email-registration-complete-via-vitec-to-broker`)
        .then(response => {
          this.emailTemplate = response.data.html
        })
        .catch(error => {
          console.log(error.response.data.devMessage)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/Settings/DevPageViews/Emails.vue